module.exports = __webpack_public_path__ + "static/media/report-search.0d1332d9.svg";